import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {langTypes} from "../common/enums/ExcelEnum";


const logPrefix = "[OddStepOneStore]"
export default class OddStepOneStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.init();
        makeAutoObservable(this);
    }

    init = () => {
        this.contentTapIndex = 0;
        this.contentList = null;
        this.originalContentList = null;
        this.tempContentList = null;
        this.isProcessing = false;
        this.popoverState = false;
        this.askToRemove = true;
        this.dividedNumber = 0;
        this.popoverState = false;
    }

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
        this.isProcessing = false;
    };

    setPopoverState = (boolean) => {
        if (this.popoverState !== null) {
            this.popoverState = boolean;
        }
    }

    setIsProcessing = (isProcessing) => {
        this.isProcessing = isProcessing;
    }

    setChangeAskToRemove = (bool) => {
        this.askToRemove = bool;
    }

    setDividedNumber = (num) => {
        this.dividedNumber = num;
    };

    getSelectedContent = () => {
        return this.contentList.find(content => content.languageCode === langTypes[this.contentTapIndex]);
    }

    getSelectedTempContent = () => {
        return this.tempContentList.find(content => content.languageCode === langTypes[this.contentTapIndex]);
    }

    getContent = (index) => {
        return this.contentList.find(content => content.languageCode === langTypes[index]);
    }

    getTempContent = (index) => {
        return this.tempContentList.find(content => content.languageCode === langTypes[index]);
    }

    savePieceListTextIndex = () => {
        const content = this.getSelectedContent();
        const tempContent = this.getSelectedTempContent();

        let pieceList = this.dividedNumber === 1 ? content.topPieceList : content.bottomPieceList;
        const tempPieceList = this.dividedNumber === 1 ? tempContent.topPieceList : tempContent.bottomPieceList;

        let isChange = false;
        if (pieceList.length === tempPieceList.length) {
            for (let i = 0; i < pieceList.length; i++) {
                if (pieceList[i].textStartIndex !== tempPieceList[i].textStartIndex || pieceList[i].textEndIndex !== tempPieceList[i].textEndIndex) {
                    isChange = true;
                    break;
                }
            }
        } else {
            isChange = true;
        }

        if (isChange) {
            pieceList = [];
            for (let i = 0; i < tempPieceList.length; i++) {
                tempPieceList[i].splitCount = tempPieceList.length;
                tempPieceList[i].sequence = i + 1;
                pieceList.push(tempPieceList[i]);
            }

            if (this.dividedNumber === 1) {
                content.topPieceList = pieceList;
            } else {
                content.bottomPieceList = pieceList;
            }
        }
    }

    saveTempContentList = () => {
        this.tempContentList = JSON.parse(JSON.stringify(this.contentList));
    }

    isChangeContent = () => {
        return JSON.stringify(this.originalContentList) !== JSON.stringify(this.contentList);
    }

    sortPieceList = (pieceList) => {
        pieceList.sort((a,b) => a.textStartIndex - b.textStartIndex);
    }

    setPieceTextIndex = (piece, textStartIndex, textEndIndex) => {
        piece.textStartIndex = textStartIndex;
        piece.textEndIndex = textEndIndex;
    }

    addPiece = (pieceList, piece) => {
        pieceList.push(piece);
    }

    removePiece = (pieceList, index) => {
        pieceList.splice(index, 1);
    }

    getKoContent = () => {
        const koContent = this.contentList && this.contentList.find(content => content.languageCode === langTypes[0]);
        if (koContent) {
            return koContent;
        }
    }

    getImage = () => {
        const koContent = this.getKoContent();

        if (koContent) {
            return koContent.image;
        } else {
            return null;
        }
    }

    setImage = (image) => {
        const koContent = this.getKoContent();

        if (koContent) {
            koContent.extension = 'jpeg';
            koContent.image = image.split(',')[1];
            koContent.generateType = 'AI';
            koContent.changeImage = true;
        }
        this.contentStore.setReadyToSaveStep(true);
    }

    uploadImage = (fileName, extension, image) => {
        const koContent = this.getKoContent();
        koContent.originalFileName = fileName;
        koContent.extension = extension;
        koContent.image = image;
        koContent.generateType = 'Upload';
        koContent.changeImage = true;
    }

    getImageText = () => {
        const koContent = this.getKoContent();

        if (koContent) {
            return koContent.imageDescription;
        } else {
            return null;
        }
    }

    setImageText = (text) => {
        this.getKoContent().imageDescription = text;
    }

    getDividedText = (start, end) => {
        return this.getContent(this.contentTapIndex).text.slice(start, end);
    }

    setText = (content, text) => {
        content.text = text;
    }

    clearPieceList = (content) => {
        content.topPieceList = [];
        content.bottomPieceList = [];
    }

    isOddStepOneCompleted = (dataArray) => {
        if (dataArray.length < 4) {
            return false;
        }

        for (let i = 0; i < 4; i++) {
            const data = dataArray[i];
            if (data.languageCode === 'KO') {
                if (data.image === '' || (data.image === null)) {
                    return false;
                }
            }

            if (data.topPieceList.length === 0) {
                return false;
            }
            if (data.bottomPieceList.length === 0) {
                return false;
            }
        }
        return true;
    }

    * getOddStepOneContent(step, day, callback) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getOddStepOneContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/1`;
            const response = yield this.contentRepository.getContent(url);
            console.log(logPrefix, 'Finished getOddStepOneContent.');

            this.contentList = response.data;
            this.originalContentList = JSON.parse(JSON.stringify(this.contentList));
            this.tempContentList = JSON.parse(JSON.stringify(this.contentList));

            this.isOddStepOneCompleted(response.data);
            callback && callback(response.data);
        } catch (e) {
            console.log(logPrefix, 'Failed getOddStepOneContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyOddStepOneContent(step, day, callback) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyOddStepOneContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/1`;
            const response = yield this.contentRepository.putContent(url, this.contentList);

            console.log(logPrefix, 'Finished modifyOddStepOneContent : ', response);
            callback && callback();
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyOddStepOneContent.');
            this.openErrorDialog({
                titleText: '본문 수정 오류',
                text: displayErrorDialogPrompt(e, '본문 수정 작업중 에러가 발생했습니다.')
            });
        }
    }

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }
}

